
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/referral-program",
      function () {
        return require("private-next-pages/referral-program.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/referral-program"])
      });
    }
  